import React, { useState } from 'react'
import { Link } from "react-router-dom";
import { Radio, Select, Col, Row, Input, Checkbox, Table, Modal } from "antd";
import backButton from '../../assets/images/back_button_arrow.svg';
import listbreadcrumbsIcon from '../../assets/images/icons/list_breadcrumbs.svg';
import deleteIcon from '../../assets/images/icons/trash.svg';
import csvIcon from '../../assets/images/icons/csv.svg';
import txtIcon from '../../assets/images/icons/txt.svg';
import uploadIcon from '../../assets/images/icons/upload-cloud.svg';

function resetFormView() { };

const CreateAppBundleList = ({ handlePageViewChange }) => {


    const onChangedate = (date, dateString) => {
        console.log(date, dateString);
    };
    const [search, setSearch] = useState("");
    // const [filteredData, setFilteredData] = useState(data);
    const [loading, setLoading] = useState(true);

    return (
        <div className='container_box--wrapper pt_header'>
            <div className="container_box--breadcrumb">
                <ul className="container_box--breadcrumb-list">
                    <li>
                        <Link onClick={() => {
                            handlePageViewChange("table")
                            resetFormView()
                        }}>
                            <img src={listbreadcrumbsIcon} alt="USP" /> List Manager
                        </Link>
                    </li>
                    <li>App Bundle List</li>
                    <li className="primary">Create App Bundle List</li>
                </ul>
            </div>
            <div className="container_box--wrapper--title d_flex justify-content-between align-items-center">
                <div className="back_btn_d2">
                    <img src={backButton} className="img-fluid" alt=""
                        onClick={() => {
                            handlePageViewChange("table")
                            resetFormView()
                        }} />
                    <h1 className="heading"> Create App Bundle List </h1>
                </div>
            </div>
            <div className="container_box--content pt_20 form_scrollable_div_d2">
                <div className="container_box--width">

                    <Row gutter={16}>
                        <Col span={8}>
                            <div className="container_box--label-info">
                                <label>List Details</label>
                            </div>
                        </Col>

                        <Col span={16}>
                            <div className="container_box--form-container">
                                <Row gutter={16}>
                                    <Col span={24}>
                                        <div className="form_content_block--group">
                                            <label className="form_label">Advertiser </label>
                                            <Select
                                                showSearch
                                                className='form_select basic no_search'
                                                placeholder=""
                                                optionFilterProp="label"
                                                options={[
                                                    {
                                                        value: 'jack',
                                                        label: 'Jack',
                                                    },
                                                    {
                                                        value: 'lucy',
                                                        label: 'Lucy',
                                                    },
                                                    {
                                                        value: 'tom',
                                                        label: 'Tom',
                                                    },
                                                ]}
                                            />
                                            <span className="error_content"> </span>
                                        </div>
                                        <div className="form_content_block--group hide_caret_after_select_value">
                                            <label className="form_label">Name *</label>
                                            <Input className='form_control basic ' placeholder='' autocomplete="off" />
                                            <span className="error_content"> </span>
                                        </div>
                                        <div className="form_content_block--group mb-0">
                                            <label className="form_label">IP Addresses * </label>
                                            <label for='fileUploader' className='ant_upload_drag'>
                                                <p className="upload_drag_icon"> <img src={uploadIcon} alt='USP' /></p>
                                                <p className="ant_upload_text"><b className="primary">Click to upload</b> or drag and drop</p>
                                                <p className="ant_upload_hint"> TXT or CSV (max. 100 MB) </p>
                                            </label>
                                            <input className='form_upload d-none' type="file" id="fileUploader" name="fileUploader" />
                                        </div>
                                        <div class="ant_upload_list--item mb-0 mt-4">
                                            <div class="ant_upload_list--content">
                                                <img src={csvIcon} alt="USP" />
                                                <img src={txtIcon} alt="USP" />
                                                <div class="ant_upload_list--info">
                                                    <span class="ant_upload_list--info-name">Xapads_mediakit.csv</span>
                                                    <span class="ant_upload_list--info-size">4 MB</span>
                                                </div>
                                            </div>
                                            <button type="link" class="ant_upload_list--delete download_icon_d2">
                                                <img src={deleteIcon} alt="USP" />
                                            </button>
                                        </div>
                                    </Col>
                                </Row>
                            </div>
                        </Col>
                    </Row>
                </div >
                <div className="hr_custom mb_20"></div>
                <div className="btn_group justify-content-end gap_8 pb_50">
                    <button className="w_120_d2 btn btn_white_outline w_fit_content"> Discard </button>
                    <button className="w_120_d2 btn btn_primary w_fit_content">Submit</button>
                </div>
            </div >
        </div>
    )
}

export default CreateAppBundleList

